type EngagementDescriptionProps = {
  description: string;
  isCalendlyBooking: boolean;
  isIntakeFormOpen: boolean;
};

export function EngagementDescription({
  description,
  isCalendlyBooking,
  isIntakeFormOpen,
}: EngagementDescriptionProps) {
  if (isCalendlyBooking) {
    return (
      <p className="text-gray-700 italic">
        Scheduled consultation via Calendly - details managed through Calendly
      </p>
    );
  }

  if (isIntakeFormOpen) {
    return (
      <p className="text-gray-700 italic">
        Opened the provider intake form - details managed through the form
      </p>
    );
  }

  return <p className="text-gray-700 line-clamp-3">{description}</p>;
}
